
export default {
    data() {
        return {
            chars: /[^A-Za-z\dÀÁÂÄÃÅàáâäãå!?"'Çç#$ÉÈÊËéèêë%&‘`()[\]{}ÌÍÏÎìíïî*+\-.:,;/Ññ<>ÒÓÔÖÕØŒòóôöõøœ=@^_|~ÙÚÛÜùúûüÿÆ° ]/,
        }
    },
    methods: {
        containsSpecialChars(artwork) {
            for(var content of artwork.content) {
                if ((content.hasTextL1 && this.chars.test(content.textL1)) || (content.hasTextL2 && this.chars.test(content.textL2))){
                    return true;
                }
            }

            if (this.$store.getters.isDouble || this.$store.getters.isTriple) {
                for(var rightContent of artwork.rightContent) {
                    if ((rightContent.hasTextL1 && this.chars.test(rightContent.textL1)) || (rightContent.hasTextL2 && this.chars.test(rightContent.textL2))){
                        return true;
                    }
                }
            }
            if (this.$store.getters.isTriple) {
                for(var tripleRightContent of artwork.tripleRightContent) {
                    if ((tripleRightContent.hasTextL1 && this.chars.test(tripleRightContent.textL1)) || (tripleRightContent.hasTextL2 && this.chars.test(tripleRightContent.textL2))){
                        return true;
                    }
                }                   
            }
            
            return false;
        },
        contains(string) {
            string.contains()
        }

    }
  };